import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-199" data-mp="1wausa6zkfour" />, document.getElementById('root'));